// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"b87314bd","787":"c4e7f8f9","998":"1909a81a"}[chunkId] + ".chunk.js";
};